"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaggableEntityType = void 0;
var TaggableEntityType;
(function (TaggableEntityType) {
    TaggableEntityType["Location"] = "location";
    TaggableEntityType["Route"] = "route";
})(TaggableEntityType || (exports.TaggableEntityType = TaggableEntityType = {}));
//# sourceMappingURL=TaggableEntityType.js.map